export default {
  key: 'answerCountOnPresentingScreen',
  type: 'boolean',
  label: 'Answer count on the presenting screen',
  description: 'Shows how many answers have come in at the bottom right of the screen while you present.',
  default: true,
  group: 'Presenting',
}
